import { useEffect, useState } from "react";

import PropTypes from "prop-types";


import { apiClient, getErrorMessage } from "../../shared";
import { useSnackbar } from "../../ui";
import { UnitOfMeasurementFormDialog } from "../unit-of-measurement-form-dialog";

import { Button } from "@mui/material";

export const EditUnitOfMeasurementFormDialog = ({
  isOpen,
  onClose,
  unitOfMeasurementId,
  onSubmitted,
}) => {
  const { showSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(true);
  const [defaultValues, setDefaultValues] = useState(null);

  useEffect(() => {
    if (!isOpen) return;

    const fetchMetric = async () => {
      setIsLoading(true);
      try {
        const {
          data: {
            data: { name, status },
          },
        } = await apiClient.get(`unit-of-measurements/${unitOfMeasurementId}`);
        setDefaultValues({
          name,
          status,
        });
      } finally {
        setIsLoading(false);
      }
    };

    fetchMetric();
  }, [isOpen, unitOfMeasurementId]);

  const handleSubmit = async ({ name, status }) => {
    try {
      await apiClient.put(`unit-of-measurements/${unitOfMeasurementId}`, {
        name,
        status,
      });

      onSubmitted();
      onClose();
    } catch (error) {
      showSnackbar(getErrorMessage(error, "Gagal memperbarui satuan ukuran"));

      throw error;
    }
  };

  return (
    <UnitOfMeasurementFormDialog
      isOpen={isOpen}
      onClose={onClose}
      dialogTitle="Ubah Satuan Ukuran"
      isLoading={isLoading}
      defaultValues={defaultValues}
      onSubmit={handleSubmit}
      renderDialogActionsChildren={({ isLoading }) => (
        <Button loading={isLoading} variant="contained" type="submit">
          Simpan
        </Button>
      )}
    />
  );
};

EditUnitOfMeasurementFormDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmitted: PropTypes.func.isRequired,
  unitOfMeasurementId: PropTypes.string,
};
